import OperacionesLayout from './OperacionesLayout.vue';
import OperacionesPage from './operaciones/OperacionesPage.vue';
import EstrategiasPage from './estrategias/EstrategiasPage.vue';

export const operacionesRoutes = {
  path: 'operaciones',
  component: OperacionesLayout,
  children: [
    {
      path: 'estrategias',
      name: 'Estrategias',
      component: EstrategiasPage,
      meta: {
        moduleAccess: 'Estrategias'
      }      
    },
    {
      path: 'presentes_futuras',
      name: 'Presentes / futuras',
      component: OperacionesPage,
      props: { historico: false },
      meta: {
        moduleAccess: 'Operaciones',
      },
    },
    {
      path: 'Historico',
      name: 'Historico',
      component: OperacionesPage,
      props: { historico: true },
      meta: {
        moduleAccess: 'Operaciones',
      },
    },
  ],
  meta: {
    moduleAccess: '',
    requireAuth: true,
    title: 'nav_bar.operaciones',
  },
};
